import React from 'react'
import { Pencil, TextParagraph, Puzzle } from 'react-bootstrap-icons'
import styles from './styles.module.scss'
import { colors, fontSizes } from "../../../constants/salesStyles"
import useHoverHandler from "../../../hooks/sales/useHoverHandler"
import SalesRow from '../../_atoms/SalesRow/SalesRow'
import SalesText from '../../_atoms/SalesText/SalesText'
import SalesTableData from "../../_atoms/SalesTableData/SalesTableData"
import { apiMarketplacesInfoItem } from "../../../types/sales/salesTypes"
import CopyButton from '../../_atoms/CopyButton/CopyButton'

interface IProps {
    infoItem: apiMarketplacesInfoItem
    pencilOnClick: () => void
    descOnClick: () => void
    profilesOnClick?: () => void
}

const SalesCardRowMarketplaces = ({ infoItem, pencilOnClick, descOnClick, profilesOnClick }: IProps) => {
    const [, hoverOn, hoverOff] = useHoverHandler()

    const formateTime = (timestamp: string, type: string) => {
        const date = new Date(timestamp)
        const day = ("0" + date.getDate()).slice(-2)
        const month = ("0" + (date.getMonth() + 1)).slice(-2)
        const hours = ("0" + date.getHours()).slice(-2)
        const minutes = ("0" + date.getMinutes()).slice(-2)

        if (type === 'date') {
            return `${day}.${month}`
        } else {
            return `${hours}:${minutes}`
        }
    }

    const getDifference = (difference: number) => {
        if (difference > 0) {
            return `+${difference.toLocaleString('ru-RU')}`
        } else {
            return `${difference.toLocaleString('ru-RU')}`
        }
    }

    return (
        <SalesRow hoverOn={hoverOn} hoverOff={hoverOff}>
            <>
                <SalesTableData widthInPixels={30} justifyContent={'center'}>
                    <img className={styles.icon} src={infoItem.icon} alt={infoItem.alias + 'icon'}/>
                </SalesTableData>
                <SalesTableData widthInPixels={170}>
                    <>
                        <SalesText
                            text={infoItem.title}
                            color={colors.blue}
                        />
                        {infoItem.link && <CopyButton copyText={infoItem.link} overlayText={`Ссылка на ${infoItem.alias === 'vk' ? 'YML' : 'XML'} файл для ${infoItem.title} скопирована`}/>}
                        {infoItem.linkCsv && <CopyButton copyText={infoItem.linkCsv} caption="csv" overlayText={`Ссылка на CSV файл для ${infoItem.title} скопирована`}/>}
                        {infoItem.linkXlsx && <CopyButton copyText={infoItem.linkXlsx} caption="xlsx" overlayText={`Ссылка на XLSX файл для ${infoItem.title} скопирована`}/>}
                        {infoItem.linkGz && <CopyButton copyText={infoItem.linkGz} caption="gz" overlayText={`Ссылка на GZ архив для ${infoItem.title} скопирована`}/>}
                    </>
                </SalesTableData>
                <SalesTableData widthInPixels={80} justifyContent={'flex-end'}>
                    <>
                        {infoItem.date &&
                        <>
                            <SalesText
                                text={formateTime(infoItem.date, 'date')}
                                fontSize={fontSizes.xs}
                            />
                            <SalesText
                                text={formateTime(infoItem.date, 'time')}
                                fontSize={fontSizes.xs}
                                marginLeftPixels={4}
                            />
                        </>}
                    </>
                </SalesTableData>
                <SalesTableData widthInPixels={80} justifyContent={'flex-end'}>
                    <SalesText
                        text={infoItem.publishedPartsCount ? infoItem.publishedPartsCount.toLocaleString('ru-RU') : '0'}
                        fontSize={fontSizes.xs}
                        color={colors.black}
                    />
                </SalesTableData>
                <SalesTableData widthInPixels={60} justifyContent={'flex-start'}>
                    {infoItem.publishedPartsCount !== infoItem.previousCount ?
                        <SalesText
                            text={getDifference(infoItem.publishedPartsCount - infoItem.previousCount)}
                            fontSize={fontSizes.xs}
                            marginLeftPixels={8}
                            color={infoItem.publishedPartsCount - infoItem.previousCount > 0 ? colors.green : colors.purple}
                        />
                        : <></>
                    }
                </SalesTableData>
                <SalesTableData widthInPixels={60} justifyContent={'flex-end'}>
                    <div className={styles.actions}>
                        {infoItem.alias === 'avito' && profilesOnClick && (
                            <span className={styles.profiles} style={{ color: colors.purple }} onClick={profilesOnClick}>
                                <Puzzle color={colors.purple}/>
                            </span>
                        )}
                        <div className={styles.pencil} onClick={descOnClick} title="Дополнительное описание">
                            <TextParagraph color={colors.purple}/>
                        </div>
                        <div className={styles.pencil} onClick={pencilOnClick} title="Настройки выгрузки">
                            <Pencil color={colors.purple}/>
                        </div>
                    </div>
                </SalesTableData>
            </>
        </SalesRow>
    )
}

export default SalesCardRowMarketplaces
